<template>
  <div>
    <RefreshResults
      v-if="showRefreshNotification"
      :type="'car'"
      @clearResults="clearResults"
      @refreshSearch="refreshSearch"
    />
    <div v-else>
      <div :style="meetingCarResult ? 'margin: auto;' : ''">
        <div>
          <div v-if="items.length > 0">
            <div v-if="sortedfilteredItems">
              <div class="mt-1 mb-2" :class="pathMixin_isMeeting ? 'box' : ''">
                <CarFiltersDropdowns
                  v-model="filters"
                  :formData="formData"
                  :sortOptions="sortOptions"
                  :availableChains="availableProviders"
                  :preferredVendors="preferredVendors"
                  :filteredChains="filteredProviders"
                  :availableCategories="availableCategories"
                  :filteredCategories="filteredCategories"
                  :availableTypes="availableTypes"
                  :filteredTypes="filteredTypes"
                  :availableVehicleTypes="availableVehicleTypes"  
                  :filteredVehicleTypes="filteredVehicleTypes"   
                  :vendorsCars="$globals.vendors.carProviders"
                  :mapView="mapView"
                  :priceRange="priceRange"
                  :sliderData="sliderData"
                  :availablePolicies="availablePolicies"
                  :highestRating="highestRating"
                  :highlights="highlightedFilters"
                  :originalPriceRange="originalPriceRange"
                  :currencyCode="currencyCode"
                  @clearFilters="defaultFilters()"
                  @resetFilter="resetFilter"
                />
              </div>

              <div class="container my-5" style="max-width: 660px" v-if="soldOutLocations.length > 0">
              <article class="message is-warning">
                <div class="message-header has-text-left">

                  <b-icon icon="alert" size="is-small"></b-icon>

                  <div class="has-text-weight-normal">There are additional car rental locations nearby that may be sold out.</div>
                  <a
                    class="is-underlined has-text-weight-semibold"
                    v-if="showSoldOutLocations == false"
                    @click="showSoldOutLocations = true"
                    >View details <i class="mdi mdi-chevron-down"></i></a
                  >
                  
                  <a
                    class="is-underlined has-text-weight-semibold"
                    v-if="showSoldOutLocations == true"
                    @click="showSoldOutLocations = false"
                    >Hide details <i class="mdi mdi-chevron-up"></i></a
                  >

                </div>
                <div class="message-body" v-if="showSoldOutLocations">
                  <div >
                    <div class="mb-2">
                      The following locations returned no
                      inventory:
                    </div>

                    <ul>
                      <li
                        v-for="(location, index) in soldOutLocations.slice(
                          0,
                          10
                        )"
                        :key="index"
                      >
                        <div class="">
                          {{ location.companyInformation.companyName }}
                          ({{ $helpers.capitalize(location.address.addressInfo.address) }}
                          {{ location.address.postalCode }})

                          <span v-if="location.distance"
                            >({{ location.distance }} miles)</span
                          >
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </article>
            </div>

              <div
                v-if="!(sortedfilteredItems.length > 0) && !loading"
                style="text-align: center"
              >
                <b-message aria-close-label="Close message">
                  No results found for this search.<br />
                  Try removing some filters to see more results.<br />
                  <b-button @click="defaultFilters()" type="is-primary"
                    >Restore defaults</b-button
                  >
                </b-message>
              </div>

              <div v-else>
                <div
                  data-test="car_results_list"
                  class="pt-4"
                >
                  <HiddenResultsNotification
                    v-if="hiddenItemsCount > 0"
                    :hiddenItemsCount="hiddenItemsCount"
                  ></HiddenResultsNotification>

                  <!-- Controls Row -->
                  <div class="car-controls-row">
                    <div class="grouping-toggle">
                      <button
                        :class="{ active: groupBy === 'vendor' }"
                        @click="setGroupBy('vendor')"
                      >
                        <b-icon icon="domain" size="is-small"></b-icon> Vendor
                      </button>
                      <button
                        :class="{ active: groupBy === 'type' }"
                        @click="setGroupBy('type')"
                      >
                        <b-icon icon="car" size="is-small"></b-icon> Type
                      </button>
                    </div>
                    <div class="view-toggle">
                      <button
                        :class="{ active: viewMode === 'card' }"
                        @click="setViewMode('card')"
                      >
                        <b-icon icon="view-grid" size="is-small"></b-icon> Cards
                      </button>
                      <button
                        :class="{ active: viewMode === 'list' }"
                        @click="setViewMode('list')"
                      >
                        <b-icon icon="format-list-bulleted" size="is-small"></b-icon> List
                      </button>
                    </div>
                  </div>

                  <div v-if="mapView" style="margin: auto;">
                    <GMapView
                      :lat="pickupLatitude"
                      :long="pickupLongitude"
                      :cars="true"
                      :locations="this.locationInfo"
                      :addingData="addingData"
                      @selected="selectedByMap"
                    />
                  </div>

                  <!-- Grouped Car Results -->
                  <div v-else class="car-groups-container">
                    <!-- Global Immediate Travel Warning -->
                    <TripAlertBanner :advice="globalBookingAdvice" />

                    <!-- Group Navigation Section -->
                    <div v-if="groupedItems.length > 1" class="group-navigation-section">
                      <div class="group-navigation-tabs">
                        <div class="group-navigation-heading">Jump to:</div>
                        <button
                          v-for="group in groupedItems"
                          :key="'nav-' + group.key"
                          class="group-nav-tab"
                          :class="isPreferredGroup(group) ? 'preferred': ''"
                          @click="scrollToGroup(group.key)"
                        >
                          <img v-if="groupBy === 'vendor' && group.logo" :src="group.logo" class="group-nav-logo" :alt="group.label" />
                          <b-icon v-else :icon="getGroupIcon(groupBy)" size="is-small"></b-icon>
                          <span>{{ group.label }}</span>
                          <b-icon v-if="isPreferredGroup(group)" icon="star" size="is-small"></b-icon>
                          <span class="group-nav-count">({{ group.items.length }})</span>
                        </button>
                      </div>
                    </div>

                    <div
                      v-for="group in groupedItems"
                      :key="group.key"
                      class="car-group"
                      :id="'group-' + group.key"
                    >
                      <!-- Group Header -->
                      <div class="group-header" :class="{ 'has-location': groupBy === 'vendor' && group.items[0] && getLocation(group.items[0].pickupInfo.locationKey) }">
                        <!-- Vendor Identity Row (Mobile: includes count, Desktop: fixed-width) -->
                        <div class="group-header-identity">
                          <span class="group-header-label">
                            <img v-if="groupBy === 'vendor' && group.logo" :src="group.logo" class="group-vendor-logo" :alt="group.label" />
                            <b-icon v-else :icon="getGroupIcon(groupBy)" size="is-small"></b-icon>
                            <span class="group-vendor-name">{{ group.label }}</span>
                            <span v-if="isPreferredGroup(group)" class="tag preferred-vendor-tag">
                              <b-icon icon="star" size="is-small"></b-icon>
                              Preferred
                            </span>
                          </span>
                          <!-- <span class="group-count mobile-only">{{ group.items.length }} vehicle{{ group.items.length !== 1 ? 's' : '' }}</span>-->
                        </div>

                        <!-- Location Info -->
                        <div v-if="groupBy === 'vendor' && group.items[0] && getLocation(group.items[0].pickupInfo.locationKey)" class="group-location-info">
                          <div v-if="sameDropoff" class="location-row">
                            <b-icon icon="map-marker" size="is-small" class="location-icon"></b-icon>
                            <span class="location-label">PICKUP & DROPOFF</span>
                            <span class="location-separator">·</span>
                            <span class="location-name">{{ getLocationName(group.items[0].pickupInfo.locationKey) }}</span>
                            <a @click="openLocationDetails(group.items[0].pickupInfo.locationKey)" class="location-details-link">Details →</a>
                          </div>
                          <div v-else class="location-stacked">
                            <div class="location-row">
                              <b-icon icon="map-marker" size="is-small" class="location-icon"></b-icon>
                              <span class="location-label">PICKUP</span>
                              <span class="location-separator">·</span>
                              <span class="location-name">{{ getLocationName(group.items[0].pickupInfo.locationKey) }}</span>
                              <a @click="openLocationDetails(group.items[0].pickupInfo.locationKey)" class="location-details-link">Details →</a>
                            </div>
                            <div class="location-row">
                              <b-icon icon="map-marker" size="is-small" class="location-icon"></b-icon>
                              <span class="location-label">DROPOFF</span>
                              <span class="location-separator">·</span>
                              <span class="location-name">{{ getLocationName(group.items[0].dropoffInfo.locationKey) }}</span>
                              <a @click="openLocationDetails(group.items[0].dropoffInfo.locationKey)" class="location-details-link">Details →</a>
                            </div>
                          </div>
                        </div>

                        <!-- Desktop Count (far right) -->
                        <span class="group-count desktop-only">{{ group.items.length }} vehicle{{ group.items.length !== 1 ? 's' : '' }}</span>
                      </div>

                      <!-- List View -->
                      <div v-if="viewMode === 'list'" class="list-view">
                        <div
                          v-for="item in group.items"
                          :key="item.id"
                          class="compact-list-item"
                          data-test="car_item"
                          :data-id="item.id"
                        >
                          <!-- Desktop: Single Row Layout (4 Columns) -->
                          <div class="desktop-single-row">
                            <!-- Section 1: Car Info (Image + Name/Details) -->
                            <div class="section-car-info">
                              <img
                                class="compact-car-image"
                                :src="getCarPhoto(item.vehicleInfo.photo)"
                                :alt="item.vehicleInfo.displayName"
                                loading="lazy"
                              />
                              <div class="compact-car-info-text">
                                <div class="compact-car-name">{{ item.vehicleInfo.displayName }}</div>
                                <div class="compact-car-details">
                                  {{ item.vehicleInfo.driveType }} • {{ item.vehicleInfo.passengers }} seats
                                </div>
                              </div>
                            </div>

                            <!-- Section 2: Car Tags (Dedicated Column) -->
                            <div class="section-car-tags">
                              <span v-if="item.isPreferred && groupBy === 'type'" class="tag preferred"><b-icon icon="star" size="is-small"></b-icon> Preferred</span>
                              <span v-if="item.vehicleInfo.vehicleType" class="tag electric">{{ item.vehicleInfo.vehicleType }}</span>
                              <OutOfPolicyTag v-if="item.travelPolicy" :travelPolicy="item.travelPolicy" position="is-bottom" />
                            </div>

                            <!-- Section 3: Price Info (Horizontal) -->
                            <div class="section-price-info">
                              <div class="price-daily">
                                <span class="price-amount">
                                  {{ item.pricingInfo.averagePricePerDay.toFixed(0) | formatPriceFromAmount(0, item.pricingInfo.currencyCode) }}
                                </span>
                                <span class="price-label">/ day</span>
                              </div>
                              <span class="price-divider"></span>
                              <div class="price-total">
                                <span class="price-total-amount">
                                  {{ item.pricingInfo.total.toFixed(0) | formatPriceFromAmount(0, item.pricingInfo.currencyCode) }}
                                </span>
                                <span class="price-total-label">total</span>
                              </div>
                            </div>

                            <!-- Section 4: Actions -->
                            <div class="section-actions">
                              <div class="compact-vendor" v-if="groupBy !== 'vendor'">
                                <img v-if="locationInfo[item.pickupInfo.locationKey] && locationInfo[item.pickupInfo.locationKey].logo"
                                     :src="locationInfo[item.pickupInfo.locationKey].logo"
                                     class="vendor-logo-small"
                                     :alt="item.companyInfo.name" />
                                <span v-else class="vendor-name-small">{{ $helpers.capitalize(item.companyInfo.name) }}</span>
                              </div>
                              <div class="action-buttons">
                                <b-button class="rate-details-btn" @click="openCarDetailsModal(item)">View Details</b-button>
                                <button v-if="item.isSelectable && item.immediateTravelBookingAdvice !== 'prevent'" class="quick-book-btn" @click="selectCar(item)">Book</button>
                              </div>
                            </div>
                          </div>

                          <!-- Mobile: Stacked Layout -->
                          <div class="mobile-stacked-layout">
                            <div class="compact-top-row">
                              <img
                                class="compact-car-image"
                                :src="getCarPhoto(item.vehicleInfo.photo)"
                                :alt="item.vehicleInfo.displayName"
                                loading="lazy"
                              />
                              <div class="compact-car-info">
                                <div class="compact-car-name">{{ item.vehicleInfo.displayName }}</div>
                                <div class="compact-car-details">
                                  {{ item.vehicleInfo.driveType }} • {{ item.vehicleInfo.passengers }} seats
                                </div>
                                <div class="compact-car-tags">
                                  <span v-if="item.isPreferred && groupBy === 'type'" class="tag preferred"><b-icon icon="star" size="is-small"></b-icon> Preferred</span>
                                  <span v-if="item.vehicleInfo.vehicleType" class="tag electric">{{ item.vehicleInfo.vehicleType }}</span>
                                  <OutOfPolicyTag v-if="item.travelPolicy" :travelPolicy="item.travelPolicy" position="is-bottom" />
                                </div>
                              </div>
                            </div>
                            <!-- Mobile Price & Buttons Row (2 Sections) -->
                            <div class="compact-mobile-price-buttons-row">
                              <!-- Left Section: Price -->
                              <div class="compact-price">
                                <span class="compact-price-main">
                                  {{ item.pricingInfo.averagePricePerDay.toFixed(0) | formatPriceFromAmount(0, item.pricingInfo.currencyCode) }}
                                  <span class="price-label">/ day</span>
                                </span>
                                <span class="compact-price-sub">
                                  {{ item.pricingInfo.total.toFixed(0) | formatPriceFromAmount(0, item.pricingInfo.currencyCode) }}
                                  <span class="price-total-label">total</span>
                                </span>
                              </div>

                              <!-- Right Section: Buttons -->
                              <div class="compact-mobile-buttons">
                                <b-button class="rate-details-btn" @click="openCarDetailsModal(item)">View Details</b-button>
                                <button v-if="item.isSelectable && item.immediateTravelBookingAdvice !== 'prevent'" class="quick-book-btn" @click="selectCar(item)">Book</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Card View (Carousel) -->
                      <div v-else class="card-view">
                        <div class="carousel-container">
                          <div class="carousel-scroll">
                            <div
                              v-for="item in group.items"
                              :key="item.id"
                              class="carousel-card"
                              data-test="car_item"
                              :data-id="item.id"
                            >
                              <img
                                class="carousel-car-image"
                                :src="getCarPhoto(item.vehicleInfo.photo)"
                                :alt="item.vehicleInfo.displayName"
                                loading="lazy"
                              />
                              <div class="carousel-car-name">{{ item.vehicleInfo.displayName }}</div>
                              <div class="carousel-car-details">
                                {{ item.vehicleInfo.driveType }} • {{ item.vehicleInfo.passengers }} seats
                              </div>
                              <div class="carousel-car-tags">
                                <span v-if="item.isPreferred && groupBy === 'type'" class="tag preferred"><b-icon icon="star" size="is-small"></b-icon> Preferred</span>
                                <span v-if="item.vehicleInfo.vehicleType" class="tag electric">{{ item.vehicleInfo.vehicleType }}</span>
                                <OutOfPolicyTag v-if="item.travelPolicy" :travelPolicy="item.travelPolicy" position="is-bottom" />
                              </div>
                              <div class="carousel-vendor" v-if="groupBy !== 'vendor'">
                                <img v-if="getLocation(item.pickupInfo.locationKey) && getLocation(item.pickupInfo.locationKey).logo"
                                     :src="getLocation(item.pickupInfo.locationKey).logo"
                                     class="vendor-logo-card"
                                     :alt="item.companyInfo.name" />
                                <span v-else class="vendor-name-small">{{ $helpers.capitalize(item.companyInfo.name) }}</span>
                              </div>

                              <!-- Carousel Price & Buttons (Stacked Vertically) -->
                              <div class="carousel-price-buttons-stacked">
                                <div class="carousel-price">
                                  <span class="carousel-price-main">
                                    {{ item.pricingInfo.averagePricePerDay.toFixed(0) | formatPriceFromAmount(0, item.pricingInfo.currencyCode) }}
                                    <span class="price-label">/ day</span>
                                  </span>
                                  <span class="carousel-price-sub">
                                    {{ item.pricingInfo.total.toFixed(0) | formatPriceFromAmount(0, item.pricingInfo.currencyCode) }}
                                    <span class="price-label">total</span>
                                  </span>
                      
                                </div>

                                <div class="carousel-buttons-row">
                                  <b-button class="rate-details-btn" @click="openCarDetailsModal(item)">View Details</b-button>
                                  <button v-if="item.isSelectable && item.immediateTravelBookingAdvice !== 'prevent'" class="quick-book-btn" @click="selectCar(item)">Book</button>
                                  <span v-else class="not-selectable-placeholder"></span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="loading">
            <CarResultsSkeleton
              :viewMode="viewMode"
              :groupCount="2"
              :itemsPerGroup="4"
            />
          </div>
        </div>
      </div>

      <SearchErrorMessage
        v-if="showErrors"
        :errors="errors"
        :userPayload="null"
        :code="null"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import CarResultsSkeleton from "../../SkeletonLoaders/CarResultsSkeleton.vue";
import GMapView from "../../GMap/GMapView.vue";
import HiddenResultsNotification from "../HiddenResultsNotification.vue";
import CarFiltersDropdowns from "../../Filters/CarFiltersDropdowns";
import RefreshResults from "../RefreshResults";
import bookingMixin from "../../../mixins/bookingMixin";
import meetingsMixin from "../../../mixins/meetingsMixin";
import pathMixin from "../../../mixins/pathMixin";
import SearchErrorMessage from "@/components/BookTravel/SearchErrorMessage.vue";
import { mapState } from "vuex";

import OutOfPolicyTag from "../../Tags/OutOfPolicyTag.vue";
import CarDetails from "./CarDetails.vue";
import CarViewDetailsModal from "./CarViewDetailsModal.vue";
import TripAlertBanner from "./TripAlertBanner.vue";

export default {
  name: "CarResults",
  mixins: [bookingMixin, meetingsMixin, pathMixin],
  components: {
    CarResultsSkeleton,
    GMapView,
    HiddenResultsNotification,
    CarFiltersDropdowns,
    RefreshResults,
    SearchErrorMessage,
    OutOfPolicyTag,
    TripAlertBanner,
  },
  props: {
    highestRating: [],
    formData: {
      type: Object,
      required: true,
    },
  },
  data: function() {
    return {
      items: [],
      loading: false,
      error: false,
      errors: [],
      windowWidth: window.innerWidth,
      // View and grouping state
      viewMode: 'card', // 'card' or 'list' (default: card)
      groupBy: 'vendor', // 'vendor' or 'type'
      filters: {
        sortOrder: "Price Asc",
        selectedProviders: [],
        selectedCategories: [],
        selectedTypes: [],
        selectedVehicleTypes: [],
        maxPrice: [0, 1500],
        minPolicy: "",
      },
      locationInfo: {},
      rentalLocations: [],
      selectedPickup: false,
      selectedDropoff: false,

      searchBody: {},
      refreshTimer: null,
      showRefreshNotification: false,
      highlightedFilters: {
        sorting: false,
        policy: false,
        price: false,
        vendor: false,
        type: false,
        size: false,
      },
      addingData: false,
      showSoldOutLocations: false,
    };
  },
  computed: {
    ...mapState(["bookTravel"]),
    pickupLatitude() {
      if (this.formData.pickupLocation.geocode?.latitude) {
        return this.formData.pickupLocation.geocode.latitude;
      }
      return this.formData.pickupLocation.lat;
    },
    pickupLongitude() {
      if (this.formData.pickupLocation.geocode?.longitude) {
        return this.formData.pickupLocation.geocode.longitude;
      }
      return this.formData.pickupLocation.lng;
    },
    meetingCarResult() {
      return this.$route.name == "MeetingsCarResults";
    },
    sortOptions() {
      let options = [
        { value: "Price Asc", label: "Price (Low to High)" },
        { value: "Price Desc", label: "Price (High to Low)" },
      ];

      if (this.preferredVendors.length > 0) {
        options.push({
          value: "Preferred Vendors",
          label: "Preferred Vendors",
        });
      }
      return options;
    },
    sliderData() {
      var data = this.filterItems("price").map(
        (x) => x.pricingInfo.averagePricePerDay
      );
      data = data.filter((i) => {
        return i < 1500;
      });
      data.sort((a, b) => a - b);
      return data;
    },
    hiddenItemsCount() {
      let items = this.items;

      items = items.filter((i) => {
        return !i.isVisible;
      });

      return items.length;
    },
    priceRange() {
      return this.getPriceRange(this.filterItems("price"));
    },
    originalPriceRange() {
      return this.getPriceRange(this.items);
    },
    availablePolicies() {
      return this.getPolicies(this.filteredItems);
    },
    availableProviders() {
      let items = this.items;
      return this.getProviders(items);
    },
    filteredProviders() {
      let items = this.filterItems("provider");
      if (items) {
        return this.getProviders(items);
      } else {
        return [];
      }
    },
    soldOutLocations() {
      let locations = [];
      if (this.rentalLocations.length > 0) {
        locations = this.rentalLocations.filter(
          (location) => location.availabilityCount == 0
        );
      }
      return locations;
    },
    availableCategories() {
      let items = this.items;
      return this.getCategories(items);
    },
    filteredCategories() {
      let items = this.filterItems("category");
      return this.getCategories(items);
    },
    availableTypes() {
      let items = this.items;
      return this.getTypes(items);
    },
    availableVehicleTypes() {
    let items = this.items;
    let types = {};

    items.forEach((item) => {
      const type = item.vehicleInfo.vehicleType;
      if (type) {
        // Increment the count for each type
        types[type] = (types[type] || 0) + 1;
      }
    });

    return types;
  },

  filteredVehicleTypes() {
    let filteredItems = this.filterItems("vehicleType");
    let types = {};

    filteredItems.forEach((item) => {
      const type = item.vehicleInfo.vehicleType;
      if (type) {
        // Increment the count for each type
        types[type] = (types[type] || 0) + 1;
      }
    });

    console.log("Filtered Vehicle Types:", types); // Debugging count
    return types;
  },
    filteredTypes() {
      let items = this.filterItems("type");
      return this.getTypes(items);
    },
    filteredItems() {
      return this.filterItems();
    },
    sortedfilteredItems() {
      return this.sort();
    },
    // Grouped data computed properties
    groupedItems() {
      const items = this.sortedfilteredItems;
      if (!items || items.length === 0) return [];

      const groups = {};

      items.forEach(item => {
        let groupKey;
        let groupLabel;
        let vendorLogo = null;

        switch (this.groupBy) {
          case 'vendor':
            groupKey = item.vendorCode;
            groupLabel = this.$helpers.capitalize(item.companyInfo.name);
            // Get vendor logo from locationInfo
            if (this.locationInfo[item.pickupInfo.locationKey] && this.locationInfo[item.pickupInfo.locationKey].logo) {
              vendorLogo = this.locationInfo[item.pickupInfo.locationKey].logo;
            }
            break;
          case 'type':
            groupKey = item.vehicleInfo.bodyTypeGroup || 'Other';
            groupLabel = item.vehicleInfo.bodyTypeGroup || 'Other';
            break;
          default:
            groupKey = item.vendorCode;
            groupLabel = this.$helpers.capitalize(item.companyInfo.name);
        }

        if (!groups[groupKey]) {
          groups[groupKey] = {
            key: groupKey,
            label: groupLabel,
            logo: vendorLogo,
            items: [],
            minPrice: Infinity,
            hasPreferred: false
          };
        }

        // Update logo if not set yet and we have one
        if (!groups[groupKey].logo && vendorLogo) {
          groups[groupKey].logo = vendorLogo;
        }

        // Track if group has preferred items
        if (item.isPreferred) {
          groups[groupKey].hasPreferred = true;
        }

        groups[groupKey].items.push(item);
        const price = item.pricingInfo.averagePricePerDay;
        if (price < groups[groupKey].minPrice) {
          groups[groupKey].minPrice = price;
        }
      });

      // Convert to array and apply two-tier sort:
      // 1. Preferred vendors/groups first
      // 2. Then by minimum price
      const groupsArray = Object.values(groups);

      return groupsArray.sort((a, b) => {
        // Check if groups are preferred
        const aIsPreferred = this.groupBy === 'vendor'
          ? this.preferredVendors.includes(a.key)
          : a.hasPreferred;
        const bIsPreferred = this.groupBy === 'vendor'
          ? this.preferredVendors.includes(b.key)
          : b.hasPreferred;

        // Primary sort: preferred groups first
        if (aIsPreferred && !bIsPreferred) return -1;
        if (!aIsPreferred && bIsPreferred) return 1;

        // Secondary sort: by minimum price
        return a.minPrice - b.minPrice;
      });
    },
    sortOrder() {
      return this.filters.sortOrder;
    },
    sameDropoff() {
      return !this.formData.advancedSettings.diffDropLoc;
    },
    // Global Immediate Travel Booking Advice
    globalBookingAdvice() {
      const items = this.sortedfilteredItems;
      if (!items || items.length === 0) return null;

      // Check if any item has 'prevent' status (highest priority)
      const hasPrevent = items.some(item => item.immediateTravelBookingAdvice === 'prevent');
      if (hasPrevent) return 'prevent';

      // Check if any item has 'warn' status
      const hasWarn = items.some(item => item.immediateTravelBookingAdvice === 'warn');
      if (hasWarn) return 'warn';

      return null;
    },
    updatedPolicyFilter() {
      return this.filters.minPolicy;
    },
    updatedMaxPrice0() {
      return this.filters.maxPrice[0];
    },
    updatedMaxPrice1() {
      return this.filters.maxPrice[1];
    },
    updatedSelectedTypes() {
      return this.filters.selectedTypes;
    },
    updatedSelectedSize() {
      return this.filters.selectedCategories;
    },
    updatedSelectedVendor() {
      return this.filters.selectedProviders;
    },
    mapView() {
      return this.bookTravel.showMapView.car;
    },
    showErrors() {
      return (
        this.loading == false &&
        (this.errors.length > 0 || this.items.length == 0)
      );
    },
    profile() {
      return this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ];
    },
    preferredVendors() {
      return this.profile.preferredCarVendors || [];
    },
    currencyCode(){
      return this.$store.getters["travellersAndTrips/getUserDefaultCurrency"]
    }
  },
  methods: {
    setViewMode(mode) {
      this.viewMode = mode;
    },
    setGroupBy(groupType) {
      this.groupBy = groupType;
    },
    getGroupIcon(groupType) {
      switch (groupType) {
        case 'vendor': return 'domain';
        case 'type': return 'car';
        default: return 'domain';
      }
    },
    isPreferredVendor(vendorCode) {
      return this.preferredVendors.includes(vendorCode);
    },
    isPreferredGroup(group) {
      if (this.groupBy === 'vendor') {
        return this.isPreferredVendor(group.key);
      }
      return false;
    },
    getCarPhoto(url) {
      if (!url) {
        return "/images/default-car.png";
      }
      return url;
    },
    getLocation(locationKey) {
      return this.locationInfo?.[locationKey] || null;
    },
    getLocationName(locationKey) {
      const location = this.getLocation(locationKey);
      if (!location) return '';

      if (location.airportInfo) {
        return location.airportInfo.code;
      } else {
        return location.address || location.name || 'Non-Airport';
      }
    },
    openLocationDetails(locationKey) {
      const location = this.getLocation(locationKey);
      if (!location) return;

      const details = {
        parent: this,
        component: CarDetails,
        props: {
          location: location
        },
        hasModalCard: true,
        trapFocus: true,
        width: 800
      };
      this.$buefy.modal.open(details);
    },
    openCarDetailsModal(item) {
      const pickupLocation = this.locationInfo[item.pickupInfo.locationKey] || null;
      const dropoffLocation = this.locationInfo[item.dropoffInfo.locationKey] || null;

      const details = {
        parent: this,
        component: CarViewDetailsModal,
        props: {
          item: item,
          searchBody: this.searchBody,
          pickupLocation: pickupLocation,
          dropoffLocation: dropoffLocation,
        },
        events: {
          book: (selectedItem) => {
            this.selectCar(selectedItem);
          },
        },
        hasModalCard: false,
        trapFocus: true,
        canCancel: ["escape"], // Only allow escape key, disable outside click
        customClass: "car-view-details-modal-wrapper",
        width: 700,
      };
      this.$buefy.modal.open(details);
    },
    scrollToGroup(groupKey) {
      const element = document.getElementById('group-' + groupKey);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
    selectCar(item) {
      // Replicate the CResult submission logic
      if (item.immediateTravelBookingAdvice === 'warn') {
        this.$buefy.dialog.confirm({
          message: 'You have selected a car with a pick-up time in the next few hours. Please watch your email for your Final Itinerary. If you do not receive your Final Itinerary, please contact Gant Travel Support at 877-924-0303 for assistance.',
          confirmText: 'Continue booking',
          type: 'is-info',
          hasIcon: true,
          onConfirm: () => this.processCarSelection(item)
        });
      } else if (item.immediateTravelBookingAdvice === 'prevent') {
        return; // Don't allow selection
      } else {
        this.processCarSelection(item);
      }
    },
    processCarSelection(item) {
      const puLocation = this.locationInfo[item.pickupInfo.locationKey];
      const doLocation = this.locationInfo[item.dropoffInfo.locationKey];

      // Log the event
      let eventData = {
        event_type: 'Item Added to Cart',
        event_properties: {
          item_type: 'car',
          is_meeting_mode: this.pathMixin_isMeeting,
          total_price: Number(item.pricingInfo.total.toFixed(0)),
          average_daily_price: Number(item.pricingInfo.averagePricePerDay.toFixed(0)),
          vendor: item.vendorCode,
        }
      };
      this.$app.logEvent(eventData);

      item.locationInfo = puLocation;
      item.searchBody = this.searchBody;
      item.pickupLocation = puLocation;
      item.dropoffLocation = doLocation;
      item.companyInfo.name = this.$helpers.capitalize(item.companyInfo.name);
      item.vehicleInfo.photo = this.getCarPhoto(item.vehicleInfo.photo);
      this.$store.dispatch('bookTravel/alterCarResult', item);

      if (this.pathMixin_isMeeting) {
        this.goToNextStep("summary");
      } else {
        this.$nav.pushRouteTo({ name: 'BookingItinerary' });
      }
    },
    filterItems(category = null) {
      var items = this.items;

      if (Object.keys(items).length > 0) {
        // Filter out hidden
        items = items.filter((i) => {
          return i.isVisible;
        });
        if (this.selectedPickup) {
          items = items.filter((i) => {
            return i.pickupInfo.locationKey == this.selectedPickup;
          });
        }
        if (this.selectedDropoff) {
          items = items.filter((i) => {
            return i.dropoffInfo.locationKey == this.selectedDropoff;
          });
        }
        if (
          this.filters.maxPrice &&
          category != "price" &&
          !(
            this.filters.maxPrice[0] == this.priceRange[0] &&
            this.filters.maxPrice[1] == this.priceRange[1]
          )
        ) {
          items = items.filter((i) => {
            return i.pricingInfo.averagePricePerDay <= this.filters.maxPrice[1];
          });
          items = items.filter((i) => {
            return i.pricingInfo.averagePricePerDay >= this.filters.maxPrice[0];
          });
        }
        if (this.filters.minRating) {
          items = items.filter((i) => {
            return i.overallScore >= this.filters.minRating;
          });
        }
        if (
          this.filters.selectedProviders.length > 0 &&
          category != "provider"
        ) {
          items = items.filter((i) => {
            let selectedCodes = this.filters.selectedProviders.map(
              (a) => a.code
            );
            if (selectedCodes.includes(i.companyInfo.code)) {
              return true;
            }
          });
        }
        if (
          this.filters.selectedCategories.length > 0 &&
          category != "category"
        ) {
          items = items.filter((i) => {
            return this.filters.selectedCategories.includes(
              i.vehicleInfo.categoryName
            );
          });
        }
        if (this.filters.selectedTypes.length > 0 && category != "type") {
          items = items.filter((i) => {
            return this.filters.selectedTypes.includes(
              i.vehicleInfo.bodyTypeGroup
            );
          });
        }
        if (this.filters.selectedVehicleTypes.length > 0 && category != "vehicleType") {
          items = items.filter((i) => {
            return this.filters.selectedVehicleTypes.includes(i.vehicleInfo.vehicleType);
          });
        }
        if (this.filters.minPolicy) {
          if (this.filters.minPolicy == 1) {
            items = items.filter((i) => {
              return i.travelPolicy.summary.rulesTriggeredCount == 0;
            });
          } else if (this.filters.minPolicy == 2) {
            items = items.filter((i) => {
              return i.travelPolicy.summary.hardApprovalRequiredCount == 0;
            });
          }
        }
      }

      return items;
    },
    selectedByMap(code) {
      this.toggleMapView("car");
      this.selectedPickup = code;
    },
    defaultFilters(showRestoreMessage = true) {
      if (showRestoreMessage) {
        this.$buefy.toast.open({
          message: "Please wait while we're restoring defaults",
          type: "is-info",
        });
      }
      this.filters.sortOrder = "Price Asc";
      this.filters.minPolicy = "";
      this.filters.selectedProviders = [];
      this.filters.selectedCategories = [];
      this.filters.selectedTypes = [];
      this.filters.selectedVehicleTypes = [];
      this.filters.maxPrice = [0, 1500];
    },
    resetFilter(value) {
      // console.log('resetFilter CAR: filterType', value);
      switch (value) {
        case "sortOrder":
        case "minPolicy":
          this.filters[value] = "";
          break;
        case "maxPrice":
          this.filters.maxPrice[0] = this.originalPriceRange[0];
          this.filters.maxPrice[1] = this.originalPriceRange[1];
          this.highlightedFilters.price = false;
          break;
        case "selectedProviders":
        case "selectedCategories":
        case "selectedTypes":
          this.filters[value] = [];
          break;
        case "selectedVehicleTypes":
          this.filters[value] = [];
          break;
        default:
          this.defaultFilters();
          this.highlightedFilters.price = false;
      }
    },
    pickupSelected(val) {
      this.selectedPickup = val;
    },
    dropoffSelected(val) {
      this.selectedDropoff = val;
    },
    timeConvert(time) {
      if (parseInt(time) < 10) {
        return "0" + time + ":00";
      } else {
        return time + ":00";
      }
    },

    async getData() {
      this.loading = true;
      this.error = false;
      this.items = [];

      let query = this.formData;

      let startDate = moment(query.pickupDate).format("YYYY-MM-DD");
      let endDate = moment(query.dropoffDate).format("YYYY-MM-DD");

      let pickupTime;
      let dropoffTime;

      if (typeof query.pickupTime == "number") {
        pickupTime = this.timeConvert(query.pickupTime);
      } else {
        pickupTime = query.pickupTime;
      }

      if (typeof query.dropoffTime == "number") {
        dropoffTime = this.timeConvert(query.dropoffTime);
      } else {
        dropoffTime = query.dropoffTime;
      }

      let body = {
        meta: {
          responseVersion: 'v2',
          stateful: true,
          sessionKey: null,
          normalizeResponse: true,
          travelPolicyId: null,
        },
        pickupDate: {
          date: startDate,
          time: pickupTime,
        },
        dropoffDate: {
          date: endDate,
          time: dropoffTime,
        },
      };

      if (
        this.$store.state.travellersAndTrips.travellers.tripType == "business"
      ) {
        body.meta.travelPolicyId = this.$globals.travellerProfile.travelPolicyId;
        body.meta.travelerContactId = this.$globals.travellerProfile.id;
      }

      if (query.pickupLocation) {
        if (query.advancedSettings.airportSearch === true) {
          body.pickupLocation = {
            coordinates: {
              latitude: query.pickupLocation.geocode.latitude,
              longitude: query.pickupLocation.geocode.longitude,
            },
            radius: {
              distance: 5,
              distanceUnit: "miles",
            },
          };
        } else {
          body.pickupLocation = {
            coordinates: {
              latitude: query.pickupLocation.lat,
              longitude: query.pickupLocation.lng,
            },
            radius: {
              distance: 5,
              distanceUnit: "miles",
            },
          };
        }
      }

      if (query.dropoffLocation) {
        if (query.advancedSettings.airportSearch === true) {
          body.dropoffLocation = {
            coordinates: {
              latitude: query.dropoffLocation.geocode.latitude,
              longitude: query.dropoffLocation.geocode.longitude,
            },
            radius: {
              distance: 5,
              distanceUnit: "miles",
            },
          };
        } else {
          body.dropoffLocation = {
            coordinates: {
              latitude: query.dropoffLocation.lat,
              longitude: query.dropoffLocation.lng,
            },
            radius: {
              distance: 5,
              distanceUnit: "miles",
            },
          };
        }
      }

      if (query.pickupLocation.code) {
        body.pickupLocation = {
          airportCode: query.pickupLocation.code,
        };
      }
      if (query.dropoffLocation.code) {
        body.dropoffLocation = {
          airportCode: query.dropoffLocation.code,
        };
      }

      if (query.advancedSettings.active) {
        if (query.advancedSettings.chain != []) {
          body.companyCodes = [];
          for (const [key] of query.advancedSettings.chain) {
            var company = {
              companyCode: key,
            };
            body.companyCodes.push(company);
          }
        }
      }

      // console.log('body of car: ', body);

      //get list of all nearby rental locations
      try {
        this.rentalLocations = await this.getRentalLocations(body.pickupLocation);
      } catch (error) {
        console.error('Error fetching rental locations:', error);
        this.rentalLocations = [];
      }

      await this.$app
        .huddleLabsServerCall("amadeus/car/search", body)
        .then((result) => {
          this.loading = false;

          if (result.data && result.data.length > 0) {
            // Resolve dictionary references for v2 response
            if (result.included || result.meta?.vendors) {
              this.items = result.data.map(item => {
                // Resolve vehicleInfo from carCodes dictionary
                if (item.carCode && result.included?.carCodes && result.included.carCodes[item.carCode]) {
                  item.vehicleInfo = {
                    code: item.carCode, // Preserve carCode as vehicleInfo.code for backward compatibility
                    ...result.included.carCodes[item.carCode] // Full details from dictionary
                  };
                }
                // Resolve companyInfo from meta.vendors dictionary
                if (item.vendorCode && result.meta?.vendors && result.meta.vendors[item.vendorCode]) {
                  item.companyInfo = {
                    code: item.vendorCode, // Preserve vendorCode as companyInfo.code
                    ...result.meta.vendors[item.vendorCode] // Full details from dictionary
                  };
                }
                return item;
              });
            } else {
              // v1 response - use as is
              this.items = result.data;
            }

            this.appendLocationAvailability();
            this.locationInfo = result.meta.locations;
            this.finalizeItemsLoading("car");
          } else if (result.errors) {
            this.errors = result.errors;
            this.error_id = result.meta?.error_log_id;
          } else if (result.message) {
            //general server error (no json)
            this.errors = [{ title: result.message }];
          } else {
            this.errors = [{ title: "Search failed or no results found." }];
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error('Car search error:', error);
          this.errors = [{ title: error.message || "Search failed. Please try again." }];
        });
    },
    async getRentalLocations(pickupLocation) {
      //set a radius to search rental locations
      if (!pickupLocation.radius) {
        pickupLocation.radius = {
          distance: 5,
          distanceUnit: "miles",
          significance: "road",
        };
      }

      let result = await this.$app.huddleLabsServerCall(
        "amadeus/car/location",
        {
          location: pickupLocation,
        }
      );

      let rentalLocations = [];
      if (result.data && result.data.length > 0) {
        if (pickupLocation.airportCode) {
          rentalLocations = result.data.filter(
            (item) => item.airportCode === pickupLocation.airportCode
          );
        } else {
          rentalLocations = result.data;
        }
      }

      return rentalLocations.sort((a, b) => {
        return a.distance - b.distance;
      });
    },
    appendLocationAvailability() {
      let items = this.items;
      let rentalLocations = this.rentalLocations;

      if (items.length > 0 && rentalLocations.length > 0) {
        rentalLocations.map((location) => {
          let count = items.filter((i) => {
            return (
              i.companyInfo.code == location.companyInformation.companyCode
            );
          }).length;

          location.availabilityCount = count;
        });
      }
      return rentalLocations;
    },
    selectAll() {
      this.filters.selectedProviders = this.availableProviders;
    },
    clearAll() {
      this.filters.selectedProviders = [];
    },
    getPolicies(items) {
      let policies = {};
      if (items) {
        if (items.length) {
          for (let i = 0; i < items.length; i++) {
            if (
              items[i].travelPolicy &&
              items[i].travelPolicy.summary.rulesTriggeredCount == 0
            ) {
              policies.none = true;
              policies.soft = true;
              break;
            } else if (
              items[i].travelPolicy &&
              items[i].travelPolicy.summary.hardApprovalRequiredCount == 0
            ) {
              policies.soft = true;
            }
          }
        }
      }
      return policies;
    },
    getProviders(items) {
      let providers = [];
      if (items) {
        for (let i = 0; i < items.length; i++) {
          let carrier = {
            code: items[i].companyInfo.code,
            name: this.$helpers.capitalize(items[i].companyInfo.name),
          };

          //make sure provider is unique
          if (!providers.find((c) => c.code === items[i].companyInfo.code)) {
            providers.push(carrier);
          }
        }
      }
      // return carriersList
      return providers.sort(function(a, b) {
        if (a.name < b.name) {
          return -1;
        } else {
          return 1;
        }
        // return vendors.carProviders[a] - vendors.carProviders[b]
      });
    },
    getCategories(items) {
      let carriersList = {};
      if (items) {
        for (let i = 0; i < items.length; i++) {
          var carrier = items[i].vehicleInfo.categoryName;
          if (carrier != "") {
            //carriersList.push(carrier);
            carriersList[carrier] = (carriersList[carrier] || 0) + 1;
          }
        }
      }
      return carriersList;
    },
    getTypes(items) {
      let carriersList = {};
      if (items) {
        for (let i = 0; i < items.length; i++) {
          var carrier = items[i].vehicleInfo.bodyTypeGroup;
          if (carrier != "") {
            carriersList[carrier] = (carriersList[carrier] || 0) + 1;
          }
        }
      }
      return carriersList;
    },
    getPriceRange(items) {
      let range = [];

      if (items) {
        if (items.length) {
          range = [
            items[0].pricingInfo.averagePricePerDay,
            items[0].pricingInfo.averagePricePerDay,
          ];
          for (let i = 1; i < items.length; i++) {
            var price = items[i].pricingInfo.averagePricePerDay;
            if (price < range[0]) {
              range[0] = price;
            } else if (price > range[1]) {
              range[1] = price;
            }
          }
          // range[0] = Math.round(range[0] / 100)
          // range[1] = Math.round(range[1] / 100)
        }
      }
      return range;
    },
    sort() {
      let items = this.filteredItems;

      if (this.filters.sortOrder == "Price Asc") {
        items.sort((a, b) => {
          return (
            a.pricingInfo.averagePricePerDay - b.pricingInfo.averagePricePerDay
          );
        });
      } else if (this.filters.sortOrder == "Price Desc") {
        items.sort((a, b) => {
          return (
            b.pricingInfo.averagePricePerDay - a.pricingInfo.averagePricePerDay
          );
        });
      } else if (this.filters.sortOrder == "Preferred Vendors") {
        items.sort((a, b) => {
          return this.preferredVendors.includes(a.companyInfo.code)
            ? -1
            : this.preferredVendors.includes(b.companyInfo.code)
            ? 1
            : 0;
        });
      }
      // else{
      //   this.items.sort((a, b) => {
      //     return parseFloat(a.pricingInfo.averagePricePerDay) - parseFloat(b.pricingInfo.averagePricePerDay);
      //   });
      // }
      return items;
    },
  },
  watch: {
    formData: {
      handler() {
        this.showRefreshNotification = false;
        this.getData();
      },
      deep: false,
    },
    showRefreshNotification(newVal) {
      this.setSearchRecordsStatus("car", newVal);
    },
    updatedPolicyFilter(newVal) {
      newVal !== ""
        ? (this.highlightedFilters.policy = true)
        : (this.highlightedFilters.policy = false);
    },
    updatedMaxPrice0(newVal) {
      newVal !== this.originalPriceRange[0] ||
      this.originalPriceRange[1] !== this.filters.maxPrice[1]
        ? (this.highlightedFilters.price = true)
        : (this.highlightedFilters.price = false);
    },
    updatedMaxPrice1(newVal) {
      newVal !== this.originalPriceRange[1] ||
      this.originalPriceRange[0] !== this.filters.maxPrice[0]
        ? (this.highlightedFilters.price = true)
        : (this.highlightedFilters.price = false);
    },
    updatedSelectedTypes(newVal) {
      newVal.length > 0
        ? (this.highlightedFilters.type = true)
        : (this.highlightedFilters.type = false);
    },
    updatedSelectedSize(newVal) {
      newVal.length > 0
        ? (this.highlightedFilters.size = true)
        : (this.highlightedFilters.size = false);
    },
    updatedSelectedVendor(newVal) {
      newVal.length > 0
        ? (this.highlightedFilters.vendor = true)
        : (this.highlightedFilters.vendor = false);
    },
  },
  mounted() {
    this.setSearchRecordsStatus("car", this.showRefreshNotification);
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
    this.getData();

    this.filters.sortOrder = "Price Asc";
  },
  beforeDestroy() {
    clearTimeout(this.refreshTimer);
  },
};
</script>

<style lang="scss" scoped>
/* Car Results - Controls Row */
.car-controls-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 12px;
}

/* Unified Toggle Styling */
.grouping-toggle, .view-toggle {
  display: flex;
  gap: 4px;
  background: #f8f9fa;
  padding: 4px;
  border-radius: 8px;
  width: fit-content;
}

.grouping-toggle button, .view-toggle button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  color: #666;
}

.grouping-toggle button:hover, .view-toggle button:hover {
  background: rgba(52, 152, 219, 0.08);
  color: #3498db;
}

.grouping-toggle button.active, .view-toggle button.active {
  background: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  color: #3498db;
  font-weight: 600;
}

/* Car Group */
.car-groups-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.group-navigation-section {
  margin-bottom: 20px;
}

.group-navigation-heading {
  font-size: 13px;
  font-weight: 600;
  color: #666;
  padding-left: 5px;
  letter-spacing: 0.5px;
  display: block;
  width: 100%;
}

.group-navigation-tabs {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  overflow-x: auto;
}

.group-nav-tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #2c3e50;
  transition: all 0.2s;
  white-space: nowrap;
}

.group-nav-tab.preferred > .icon {
  background: #e8f5e8;
  border-radius: 5px;
  color: #2e7d32;
}

.group-nav-tab:hover {
  background: #3498db;
  color: white;
  border-color: #3498db;
}

.group-nav-logo {
  height: 20px;
  max-width: 50px;
  object-fit: contain;
}

.group-nav-count {
  font-size: 11px;
  color: #666;
  font-weight: 400;
}

.group-nav-tab:hover .group-nav-count {
  color: rgba(255, 255, 255, 0.8);
}

.car-group {
  margin-bottom: 10px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  overflow: hidden;
  scroll-margin-top: 20px;
}

/* ========== GROUP HEADER - BASE (Mobile-first) ========== */
.group-header {
  background: #f1f3f4;
  padding: 12px 20px;
  font-weight: 600;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Vendor Identity Row */
.group-header-identity {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.group-header-label {
  display: flex;
  align-items: center;
  gap: 10px;
}

.group-vendor-logo {
  max-height: 40px;
  width: 70px;
  object-fit: contain;
  padding: 3px;
  background: #ffffff;
  border-radius: 5px;
}

.group-vendor-name {
  font-weight: 600;
}

.group-count {
  font-weight: normal;
  color: #666;
  font-size: 13px;
  white-space: nowrap;
}

/* Mobile/Desktop visibility helpers */
.mobile-only {
  display: inline;
}

.desktop-only {
  display: none;
}

/* Location Info */
.group-location-info {
  font-weight: normal;
  font-size: 13px;
  color: #444;
}

.location-stacked {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.location-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.location-icon {
  color: #575a5f;
}

.location-label {
  font-weight: 600;
  font-size: 11px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.location-separator {
  color: #999;
}

.location-name {
  font-weight: 500;
  color: #2c3e50;
}

.location-details-link {
  color: #3273dc;
  cursor: pointer;
  text-decoration: none;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.location-details-link:hover {
  text-decoration: underline;
}

/* ========== GROUP HEADER - DESKTOP (Grid-aligned) ========== */
@media screen and (min-width: 1024px) {
  .group-header {
    flex-direction: row;
    align-items: center;
    gap: 24px;
  }

  /* Desktop: hide mobile count, show desktop count */
  .mobile-only {
    display: none !important;
  }

  .desktop-only {
    display: inline !important;
  }

  /* On desktop, identity section becomes fixed-width */
  .group-header-identity {
    flex: 0 0 250px;
    max-width: 250px;
    justify-content: flex-start;
  }

  .group-vendor-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 140px;
  }

  /* Desktop count: positioned at far right of group-header */
  .group-count.desktop-only {
    flex-shrink: 0;
    margin-left: auto;
  }

  .group-location-info {
    flex: 1;
    min-width: 0;
  }

  .location-stacked {
    flex-direction: row;
    align-items: center;
    gap: 50px;
  }

  .location-label {
    min-width: 50px;
  }
}

/* Compact List View */
.list-view {
  background: white;
  max-height: 365px;
  overflow-y: auto;
}

.compact-list-item {
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
}

.compact-list-item:hover {
  background-color: #f8f9fa;
}

.compact-list-item:last-child {
  border-bottom: none;
}

/* Desktop: Single Row Layout (3 Sections) */
.desktop-single-row {
  display: none;
}

.mobile-stacked-layout {
  display: block;
}

@media screen and (min-width: 1024px) {
  .desktop-single-row {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: nowrap;
  }

  .mobile-stacked-layout {
    display: none;
  }

  /* Section 1: Car Info (flex: 1.5) */
  .section-car-info {
    flex: 1.4;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    min-width: 0;
  }

  .section-car-info .compact-car-info-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
  }

  .section-car-info .compact-car-name {
    margin-bottom: 2px;
    white-space: nowrap;
  }

  .section-car-info .compact-car-details {
    margin-bottom: 0;
    white-space: nowrap;
    font-size: 13px;
  }

  /* Section 2: Car Tags (flex: 1) - Dedicated Column */
  .section-car-tags {
    flex: 1.3;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 6px;
    min-width: 0;
  }

  /* Section 3: Price Info (flex: 1) - Horizontal Layout */
  .section-price-info {
    flex: .8;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-width: 0;
  }

  .section-price-info .price-daily {
    display: flex;
    align-items: baseline;
    gap: 2px;
  }

  .section-price-info .price-amount {
    font-size: 18px;
    font-weight: 700;
    color: #2c3e50;
  }

  .section-price-info .price-label {
    font-size: 12px;
    color: #666;
  }

  .section-price-info .price-divider {
    color: #ccc;
    font-size: 14px;
  }

  .section-price-info .price-total {
    display: flex;
    align-items: baseline;
    gap: 3px;
  }

  .section-price-info .price-total-amount {
    font-size: 14px;
    font-weight: 600;
    color: #555;
  }

  .section-price-info .price-total-label {
    font-size: 11px;
    color: #888;
  }

  /* Section 4: Actions (flex: 1) - Horizontal Layout */
  .section-actions {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    min-width: 0;
  }

  .section-actions .compact-vendor {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .section-actions .action-buttons {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }

  .section-actions .rate-details-btn {
    padding: 6px 14px;
    margin-right: 0 !important;
  }

  .section-actions .quick-book-btn {
    padding: 8px 20px;
  }

  .section-actions .not-selectable-text {
    white-space: nowrap;
    font-size: 12px;
    color: #856404;
    font-weight: 500;
  }

  .section-actions .button {
    margin-right: 0 !important;
  }
}

.compact-top-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.compact-car-image {
  width: 80px;
  height: 55px;
  object-fit: contain;
  border-radius: 4px;
  flex-shrink: 0;
}

.compact-car-info {
  flex: 1;
  min-width: 0;
}

.compact-car-name {
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 17px;
  color: #2c3e50;
}

.compact-car-details {
  font-size: 15px;
  color: #666;
  margin-bottom: 10px;
}

.compact-car-tags {
  display: flex;
  gap: 6px;
  margin-top: 0;
  flex-wrap: wrap;
  align-items: center;
}

.tag {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
}

.tag.preferred {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  background: #e8f5e8;
  color: #2e7d32;
}

.tag.preferred-vendor-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #e8f5e8;
  color: #2e7d32;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  margin-left: 8px;
}

.tag.electric {
  background: #e3f2fd;
  color: #1565c0;
}

.tag.type-tag {
  background: #fff3e0;
  color: #ef6c00;
}

.compact-vendor {
  display: flex;
  align-items: center;
  min-width: 80px;
}

.vendor-logo-small {
  height: 30px;
  max-width: 80px;
  object-fit: contain;
}

.vendor-logo-card {
  height: 40px;
  max-width: 80px;
  object-fit: contain;
  margin-top: 8px;
}

.vendor-name-small {
  font-size: 12px;
  color: #666;
}

.compact-price {
  text-align: right;
  min-width: 80px;
}

.compact-price-main {
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
}

.compact-price-sub {
  font-size: 11px;
  color: #666;
  display: block;
  margin-top: 2px;
}



.compact-vendor-price-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.quick-book-btn {
  background: #3498db;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background-color 0.2s;
  white-space: nowrap;
}

.quick-book-btn:hover {
  background: #2980b9;
}

.not-selectable-text {
  font-size: 12px;
  color: #856404;
  font-weight: 500;
  white-space: nowrap;
}

.rate-details-btn {
  border: 0.5px solid var(--color-border-secondary, #ccc);
  color: var(--color-text-secondary, #666);
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background-color 0.2s;
  white-space: nowrap;
  /* margin-right: 8px; */
}

/* Card View (Carousel) */
.card-view {
  background: white;
  padding: 10px 0;
}

.carousel-container {
  position: relative;
  overflow: hidden;
}

.carousel-scroll {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 4px;
  scrollbar-width: thin;
}

.carousel-scroll::-webkit-scrollbar {
  height: 6px;
}

.carousel-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.carousel-scroll::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.carousel-card {
  min-width: 260px;
  max-width: 300px;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 16px;
  background: white;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: transform 0.2s, box-shadow 0.2s;
  flex-shrink: 0;
}

.carousel-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0,0,0,0.15);
}

/* Desktop: Larger card size with more padding */
@media screen and (min-width: 1024px) {
  .carousel-card {
    min-width: 260px;
    max-width: 340px;
    padding: 16px;
  }
}

.carousel-car-image {
  width: 100%;
  height: 100px;
  object-fit: contain;
  border-radius: 8px;
  margin-bottom: 12px;
}

.carousel-car-name {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 6px;
  color: #2c3e50;
}

.carousel-car-details {
  font-size: 13px;
  color: #666;
  margin-bottom: 8px;
}

.carousel-car-tags {
  display: flex;
  gap: 4px;
  margin-bottom: 8px;
  flex-wrap: wrap;
  min-height: 25px;
}

.carousel-vendor {
  margin-bottom: 12px;
}



/* Carousel Price & Buttons (Stacked Vertically) */
.carousel-price-buttons-stacked {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: auto;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

/* Top Row: Price */
.carousel-price {
  display: flex;
  align-items: baseline;
  gap: 12px;
}

.carousel-price-main {
  font-size: 20px;
  font-weight: 700;
  color: #2c3e50;
}

.carousel-price-main .price-label {
  font-size: 14px;
  font-weight: 600;
}

.carousel-price-sub {
  font-size: 16px;
  font-weight: 500;
  color: #666;
}

.carousel-price-sub .price-label {
  font-size: 12px;
  font-weight: 300;
}


/* Bottom Row: Buttons (50% each) */
.carousel-buttons-row {
  display: flex;
  gap: 8px;
  width: 100%;
}

.carousel-buttons-row .rate-details-btn {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  text-align: center;
  font-size: 13px;
  padding: 8px 10px;
}

.carousel-buttons-row .quick-book-btn {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  text-align: center;
  font-size: 13px;
  padding: 8px 10px;
}

.carousel-buttons-row .not-selectable-placeholder {
  flex: 1;
  min-width: 0;
}



/* Hide mobile price-buttons row on desktop */
.compact-mobile-price-buttons-row {
  display: none;
}

/* Responsive Styles */
@media screen and (max-width: 768px) {
  .car-controls-row {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .grouping-toggle, .view-toggle {
    padding: 3px;
    gap: 3px;
  }

  .grouping-toggle button, .view-toggle button {
    padding: 6px 10px;
    gap: 4px;
  }

  /* Hide desktop elements on mobile */
  .desktop-only {
    display: none !important;
  }

  /* Show mobile price-buttons row (2 Sections) */
  .compact-mobile-price-buttons-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 8px 18px 14px 18px;
    background-color: white;
    margin: 0 -18px -18px -18px;
  }

  /* Left Section: Price */
  .compact-mobile-price-buttons-row .compact-price {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;
  }

  /* Right Section: Buttons */
  .compact-mobile-buttons {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-end;
    min-width: 0;
  }

  .compact-list-item {
    flex-direction: column;
    gap: 0;
    padding: 18px;
    align-items: stretch;
    min-height: 160px;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    margin-bottom: 12px;
  }

  .compact-top-row {
    display: flex;
    gap: 14px;
    align-items: flex-start;
    margin-bottom: 8px;
  }

  .compact-car-image {
    width: 75px;
    height: 55px;
    flex-shrink: 0;
  }

  .compact-car-info {
    flex: 1;
    min-width: 0;
    line-height: 1.6;
  }

  .compact-vendor {
    display: none;
  }

  .compact-price {
    min-width: 60px;
    text-align: left;
  }

  .compact-price-main {
    font-size: 19px;
    font-weight: 600;
  }

  .compact-price-sub {
    font-size: 14px;
  }

  .compact-mobile-buttons .quick-book-btn {
    padding: 8px 14px;
    font-size: 14px;
    white-space: nowrap;
    width: auto;
  }

  .compact-mobile-buttons .rate-details-btn {
    font-size: 14px;
    white-space: nowrap;
    padding: 8px 14px;
    width: auto;
  }

  .compact-mobile-buttons .not-selectable-text {
    font-size: 12px;
    color: #856404;
    text-align: right;
    font-weight: 500;
  }

  .not-selectable-text {
    font-size: 12px;
    color: #856404;
    font-weight: 500;
  }

  .carousel-card {
    min-width: 50vw;
    max-width: 70vw;
  }

  .carousel-scroll {
    padding: 0px 2.5vw;
  }

  .carousel-buttons-row .rate-details-btn,
  .carousel-buttons-row .quick-book-btn {
    font-size: 12px;
    padding: 6px 8px;
  }
}

@media screen and (max-width: 480px) {
  .grouping-toggle button, .view-toggle button {
    padding: 5px 8px;
    gap: 3px;
  }

  .compact-list-item {
    padding: 10px;
  }

  .compact-car-name {
    font-size: 14px;
  }

  .compact-car-details {
    font-size: 12px;
  }

  .tag.preferred-vendor-tag {
    font-size: 12px;
    padding: 2px 6px;
    margin-left: 6px;
  }

  .tag.preferred {
    font-size: 11px;
  }
}
</style>
